/* assets/product-addon.js */
/* Bundle upsell – stacked layout + live pricing + thema-knop + info-popup */
(function () {
  /* =========================
   * Bootstrapping & Re-init
   * ========================= */
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target || document;
    init(root);
  });

  function init(root) {
    ensureNoticeShell();
    initInfoPopups(root); // <<< bind info-popups

    // Alle bundle blocks binnen scope
    const wrappers = root.querySelectorAll ? root.querySelectorAll('[data-addon-wrapper]') : document.querySelectorAll('[data-addon-wrapper]');
    wrappers.forEach(initAddonBlock);

    // Hook op hoofd product form (in de hele pagina) → totals herrekenen bij qty/variant
    const mainForm = getMainForm();
    if (mainForm) {
      const recalcAll = () => document
        .querySelectorAll('[data-addon-wrapper]')
        .forEach(updateTotalForWrapper);

      mainForm.addEventListener('change', (e) => {
        if (!e.target) return;
        if (e.target.name === 'quantity' || e.target.name === 'id') recalcAll();
      });
      mainForm.addEventListener('input', (e) => {
        if (!e.target) return;
        if (e.target.name === 'quantity') recalcAll();
      });
    }
  }

  /* =========================
   * Info popup binder
   * ========================= */
  function initInfoPopups(scope) {
    const ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-addon-info-open]').forEach(btn => {
      const targetId = btn.getAttribute('data-target');
      const dlg = document.getElementById(targetId);
      if (!dlg) return;

      let lastFocused = null;

      const open = () => {
        lastFocused = document.activeElement;
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.show();
        const first = dlg.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        (first || dlg).focus();
      };
      const close = () => {
        if (dlg.open) dlg.close('close');
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      };

      btn.addEventListener('click', open);
      dlg.querySelector('.addon-info__close')?.addEventListener('click', (e) => { e.preventDefault(); close(); });
      dlg.addEventListener('click', (e) => {
        const card = dlg.querySelector('.addon-info__card');
        if (card && !card.contains(e.target)) close();
      });
    });
  }

  /* =========================
   * Per-blok initialisatie
   * ========================= */
  function initAddonBlock(wrapper) {
    if (wrapper.__addonInit) return; // idempotent
    wrapper.__addonInit = true;

    const content   = wrapper.querySelector('.addon-card__content'); // upsell content container
    const bundleBtn = wrapper.querySelector('.addon-bundle-btn') || wrapper.querySelector('[data-addon-bundle]');
    const pillsGrp  = wrapper.querySelectorAll('.addon-pills');
    if (!content || !bundleBtn) return;

    // Money formatter
    const moneyFormat = (window.theme && window.theme.moneyFormat) || window.SHOP_MONEY_FORMAT || "${{amount}}";
    const fmt = (cents) => {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, moneyFormat);
      try {
        const currency = document.documentElement.getAttribute('data-shop-currency') || 'EUR';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((+cents || 0) / 100);
      } catch (e) {
        return ((+cents || 0) / 100).toFixed(2);
      }
    };

    // Parse variants (upsell + main) uit data-attributen op wrapper/content
    let upsellVariants = [];
    try { upsellVariants = JSON.parse(content.getAttribute('data-variants') || '[]'); } catch (e) {}
    let mainVariants = [];
    try { mainVariants = JSON.parse(wrapper.getAttribute('data-main-variants') || '[]'); } catch (e) {}

    /* ----- Helpers voor varianten/pills/prijs ----- */
    const getSelectedOptions = () =>
      Array.from(pillsGrp).map(g => {
        const s = g.querySelector('.addon-pill.is-selected');
        return s ? s.dataset.value : '';
      });

    const findUpsellVariant = (opts) =>
      upsellVariants.find(v => opts.every((val, idx) => v['option' + (idx + 1)] === val));

    const existsUpsellAvailable = (partialOpts) =>
      upsellVariants.some(v => v.available && partialOpts.every((val, idx) => !val || v['option' + (idx + 1)] === val));

    function updateUpsellAvailability() {
      const current = getSelectedOptions();
      pillsGrp.forEach((group, optIndex) => {
        group.querySelectorAll('.addon-pill').forEach(btn => {
          const probe = current.slice();
          probe[optIndex] = btn.dataset.value;
          const possible = existsUpsellAvailable(probe);
          btn.classList.toggle('is-disabled', !possible);
          btn.setAttribute('aria-disabled', possible ? 'false' : 'true');
          btn.tabIndex = possible ? 0 : -1;
        });
      });
    }

    function setPrice(elRoot, priceCents, compareCents) {
      const cur = elRoot && elRoot.querySelector('.price-current');
      const cmp = elRoot && elRoot.querySelector('.price-compare');
      if (cur) {
        cur.dataset.cents = String(priceCents || 0);
        cur.textContent = fmt(priceCents || 0);
      }
      if (cmp) {
        if (compareCents && compareCents > priceCents) {
          cmp.style.display = '';
          cmp.dataset.cents = String(compareCents);
          cmp.textContent = fmt(compareCents);
        } else {
          cmp.style.display = 'none';
          cmp.dataset.cents = '';
          cmp.textContent = '';
        }
      }
    }

    function readMainState() {
      const mainForm = getMainForm();
      if (!mainForm) return null;
      const fd  = new FormData(mainForm);
      let id    = Number(fd.get('id'));
      let qty   = Number(fd.get('quantity') || 1);
      if (!id) {
        const vid = Number(new URL(window.location).searchParams.get('variant'));
        if (vid) id = vid;
      }
      if (!Number.isFinite(id) || id <= 0) return null;
      if (!Number.isFinite(qty) || qty < 1) qty = 1;

      const v = mainVariants.find(x => x.id === id);
      const price    = v ? v.price : Number(wrapper.querySelector('.addon-price--main .price-current')?.dataset.cents || 0);
      const compare  = v ? v.compare_at_price : Number(wrapper.querySelector('.addon-price--main .price-compare')?.dataset.cents || 0);
      const available = v ? !!v.available : true;
      return { id, qty, price, compare, available, title: v ? v.title : '' };
    }

    function readUpsellState() {
      const id = Number(content.dataset.addonVariantId);
      const v  = upsellVariants.find(x => x.id === id);
      const price    = v ? v.price : Number(wrapper.querySelector('.addon-price--upsell .price-current')?.dataset.cents || 0);
      const compare  = v ? v.compare_at_price : Number(wrapper.querySelector('.addon-price--upsell .price-compare')?.dataset.cents || 0);
      const available = v ? !!v.available : true;
      return { id, price, compare, available, title: v ? v.title : '' };
    }

    function updateBundleTotal() {
      const main = readMainState(); if (!main) return;
      const ups  = readUpsellState();
      const total = (main.price * main.qty) + (ups.price || 0);
      const el = wrapper.querySelector('.bundle-total');
      if (el) {
        el.dataset.totalCents = String(total);
        el.textContent = fmt(total);
      }
      // CTA disabled state als één van beide OOS is
      const soldTxt = bundleBtn?.dataset.buttonSoldout || 'Sold out';
      const addTxt  = bundleBtn?.dataset.buttonText || 'Add to cart';
      setSoldOut(bundleBtn, !(main.available && ups.available), soldTxt, addTxt);
    }

    function applyUpsellFromOptions() {
      const v = findUpsellVariant(getSelectedOptions());
      if (!v) return;

      // Zet gekozen variant-ID op dataset
      content.setAttribute('data-addon-variant-id', String(v.id));

      // Update prijsweergave upsell
      const upsellPriceRoot = wrapper.querySelector('.addon-price--upsell');
      if (upsellPriceRoot) setPrice(upsellPriceRoot, v.price, v.compare_at_price);

      // Badge toggling
      const badge = wrapper.querySelector('.addon-card__badge--oos');
      if (badge) badge.style.display = v.available ? 'none' : '';

      // CTA state + total
      const soldTxt = bundleBtn?.dataset.buttonSoldout || 'Sold out';
      const addTxt  = bundleBtn?.dataset.buttonText || 'Add to cart';
      setSoldOut(bundleBtn, !v.available, soldTxt, addTxt);
      updateBundleTotal();
    }

    /* ----- Init prijzen en initiële variantselectie ----- */
    (function initPricesAndPills() {
      // Format bestaande cent-waarden (main + upsell)
      const mainPriceRoot = wrapper.querySelector('.addon-price--main');
      const upsellPriceRoot = wrapper.querySelector('.addon-price--upsell');

      if (mainPriceRoot) {
        const pc = Number(mainPriceRoot.querySelector('.price-current')?.dataset.cents || 0);
        const cc = Number(mainPriceRoot.querySelector('.price-compare')?.dataset.cents || 0);
        setPrice(mainPriceRoot, pc, cc);
      }
      if (upsellPriceRoot) {
        const pc = Number(upsellPriceRoot.querySelector('.price-current')?.dataset.cents || 0);
        const cc = Number(upsellPriceRoot.querySelector('.price-compare')?.dataset.cents || 0);
        setPrice(upsellPriceRoot, pc, cc);
      }

      // Markeer selectie volgens current upsell-variant
      const initId = Number(content.dataset.addonVariantId);
      const current = upsellVariants.find(v => v.id === initId) || upsellVariants.find(v => v.available) || upsellVariants[0];
      if (current) {
        const parts = [current.option1, current.option2, current.option3].filter(Boolean);
        pillsGrp.forEach((g, idx) => {
          const btn = Array.from(g.children).find(b => b.dataset.value === (parts[idx] || ''));
          if (btn) {
            g.querySelectorAll('.addon-pill').forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
          }
        });
        const soldTxt = bundleBtn?.dataset.buttonSoldout || 'Sold out';
        const addTxt  = bundleBtn?.dataset.buttonText || 'Add to cart';
        setSoldOut(bundleBtn, !current.available, soldTxt, addTxt);
      }

      updateUpsellAvailability();
      updateBundleTotal();
    })();

    // Clicks op upsell variant-pills
    pillsGrp.forEach(group => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('.addon-pill');
        if (!btn || btn.classList.contains('is-disabled')) return;
        group.querySelectorAll('.addon-pill').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        applyUpsellFromOptions();
        updateUpsellAvailability();
      });
    });

    // Bundel CTA – voeg main + upsell in één call toe
    bundleBtn.addEventListener('click', async () => {
      const ups = readUpsellState();
      const main = readMainState();
      if (!ups || !main) return;
      if (!ups.available || !main.available) return;

      try {
        setLoading(bundleBtn, true);
        await addItems([{ id: main.id, quantity: main.qty }, { id: ups.id, quantity: 1 }]);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        showCartNotice(2);
      } catch (err) {
        console.error(err);
        showCartNotice(0, true);
      } finally {
        setLoading(bundleBtn, false);
      }
    });

    // Expose: total updater zodat globale hooks kunnen herrekenen
    wrapper.updateBundleTotal = () => updateBundleTotal();
  }

  function updateTotalForWrapper(wrapper) {
    if (typeof wrapper.updateBundleTotal === 'function') wrapper.updateBundleTotal();
  }

  function getMainForm() {
    return document.querySelector('form[action^="/cart/add"]') ||
           document.querySelector('form#product-form, form[action="/cart/add"]');
  }

  /* =========================
   * Cart API helper
   * ========================= */
  async function addItems(items) {
    // Validatie
    const clean = items
      .map(it => ({ id: Number(it.id), quantity: Number(it.quantity || 1) }))
      .filter(it => Number.isFinite(it.id) && it.id > 0 && it.quantity > 0);

    if (!clean.length) throw new Error('Geen geldige items om toe te voegen.');

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const url = `${root}cart/add.js`;

    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: clean })
    });

    if (!res.ok) {
      let detail = '';
      try { detail = await res.text(); } catch (e) {}
      throw new Error(`Cart add failed (${res.status}) ${detail}`);
    }
    return res.json();
  }

  /* =========================
   * Button state helpers
   * ========================= */
  function setLoading(btn, on) {
    if (!btn) return;
    const sp = btn.querySelector('.loading-overlay__spinner');
    if (on) {
      btn.setAttribute('disabled', 'disabled');
      if (sp) sp.classList.remove('hidden');
    } else {
      btn.removeAttribute('disabled');
      if (sp) sp.classList.add('hidden');
    }
  }
  function setSoldOut(btn, soldOut, soldText, addText) {
    if (!btn) return;
    const label = btn.querySelector('.bundle-cta-label') || btn.querySelector('span');
    if (soldOut) {
      btn.setAttribute('disabled', 'disabled');
      if (label) label.textContent = soldText || 'Sold out';
    } else {
      btn.removeAttribute('disabled');
      if (label) label.textContent = addText || 'Add to cart';
    }
  }

  /* =========================
   * Notice modal (bevestiging)
   * ========================= */
  function ensureNoticeShell() {
    if (document.getElementById('cart-notice')) return;
    const shell = document.createElement('div');
    shell.id = 'cart-notice';
    shell.innerHTML = `
      <div class="cn-backdrop" data-cn-close></div>
      <div class="cn-modal" role="dialog" aria-labelledby="cn-title" aria-modal="true">
        <button class="cn-close" type="button" aria-label="Sluiten" data-cn-close>✕</button>
        <h3 id="cn-title" class="cn-title"></h3>
        <p class="cn-msg"></p>
        <div class="cn-actions">
          <a class="cn-btn cn-btn--primary" href="/cart">Ga naar winkelwagen</a>
          <button class="cn-btn cn-btn--ghost" type="button" data-cn-close>Sluiten</button>
        </div>
      </div>
    `;
    document.body.appendChild(shell);
    shell.addEventListener('click', (e) => { if (e.target.matches('[data-cn-close]')) hideCartNotice(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideCartNotice(); });
  }

  function showCartNotice(itemsCount, isError) {
    const shell = document.getElementById('cart-notice'); if (!shell) return;
    const title = shell.querySelector('.cn-title');
    const msg = shell.querySelector('.cn-msg');

    if (isError) {
      title.textContent = 'Er ging iets mis';
      msg.textContent = 'Kon bundle niet toevoegen. Probeer opnieuw.';
    } else {
      const n = Number(itemsCount || 1);
      title.textContent = 'Toegevoegd aan je winkelwagen';
      msg.textContent = n > 1 ? `${n} items zijn toegevoegd.` : `1 item is toegevoegd.`;
    }

    shell.classList.add('is-open');
    shell.querySelector('.cn-close').focus();
    document.documentElement.classList.add('cn-lock');
  }

  function hideCartNotice() {
    const shell = document.getElementById('cart-notice'); if (!shell) return;
    shell.classList.remove('is-open');
    document.documentElement.classList.remove('cn-lock');
  }
})();
